import IntegrationCard from 'components/Global/IntegrationCard';
import React from 'react';
import { Col, Row } from 'antd';
import { integrationsCards } from 'constants/Data';
import styles from './index.module.scss';
import { getApi } from 'redux/apis';
import { toastText } from 'utils/utils';
import axios from 'axios';
import jwtDecode from 'jwt-decode';

// Define a type for token payload
interface OutsetaTokenPayload {
	PersonUid: string;
	nameid: string;
	[key: string]: any;
}

// Helper function to get Person ID from token
const getPersonIdFromToken = (): string | null => {
	const token = localStorage.getItem('outsetaAccessToken');
	if (!token) return null;

	try {
		const decoded: OutsetaTokenPayload = jwtDecode(token);
		return decoded.nameid || null;
	} catch (error) {
		console.error('Failed to decode token', error);
		return null;
	}
};

const Connection = () => {
	const connectionHandler = async () => {
		try {
			// 1. Get person ID from token
			const personId = getPersonIdFromToken();
			if (!personId) {
				toastText('User token not found or invalid', 'error');
				return;
			}

			// 2. Fetch person accounts
			const personResponse = await axios.get(
				`${process.env.REACT_APP_OUTSETA_BASE_URL}/crm/people/${personId}?fields=*,PersonAccount.*,PersonAccount.Account.*,PersonAccount.Account.PrimaryContact.*,PersonAccount.Account.CurrentSubscription.*,PersonAccount.Account.CurrentSubscription.Plan.*`,
				{
					headers: {
						Authorization: `Outseta ${process.env.REACT_APP_OUTSETA_API_KEY}:${process.env.REACT_APP_OUTSETA_API_SECRET}`,
						'Content-Type': 'application/json',
					},
				}
			);

			const personAccounts = personResponse.data.PersonAccount || [];
			const newPlanUid = process.env.REACT_APP_OUTSETA_PLAN_UID_2;

			if (!newPlanUid) {
				console.error('REACT_APP_OUTSETA_PLAN_UID_2 is not set in environment variables');
				toastText('Configuration error. Please contact support.', 'error');
				return;
			}

			// 3. Map and filter for PRIMARY accounts with NEW PLAN only
			const matchingAccounts = personAccounts
				.map((pa: any) => {
					const currentSubscription = pa.Account?.CurrentSubscription;
					const hasNewPlan = currentSubscription?.Plan?.Uid === newPlanUid;

					return {
						IsPrimary: pa.IsPrimary,
						AccountUid: pa.Account.Uid,
						AccountName: pa.Account.Name,
						PrimaryContactEmail: pa.Account?.PrimaryContact?.Email,
						hasNewPlan: hasNewPlan,
					};
				})
				// Filter: Must be PRIMARY AND have NEW PLAN
				.filter((acc: any) => acc.hasNewPlan === true && acc.IsPrimary === true);

			// 4. Check if any matching account found
			if (matchingAccounts.length === 0) {
				toastText('No primary accounts found with the required subscription plan. Please contact support.', 'warning');
				return;
			}

			// 5. Select the account (first one since all are primary)
			const selectedAccount = matchingAccounts[0];
			const accountUid = selectedAccount.AccountUid;

			// 6. Set the account UID in localStorage
			localStorage.setItem('outsetaAccountUidForConnection', accountUid);
			localStorage.setItem('isNewOutsetaPlan', 'true');
			localStorage.setItem('isConnectionExisting', 'false');

			// 7. Proceed with QuickBooks OAuth
			getApi('/quickbooks/authurl')
				.then((res) => {
					window.open(res.data.data, '_self');
				})
				.catch(() => {
					toastText('Something went wrong', 'error');
				});

		} catch (error) {
			console.error('Error fetching accounts:', error);
			toastText('Failed to load account details.', 'error');
		}
	};

	return (
		<Row gutter={16} className={styles['']}>
			{integrationsCards?.map((card, index) => {
				return (
					<Col
						key={index}
						className="gutter-row"
						xl={8}
						lg={8}
						md={12}
						sm={12}
						xs={24}
					>
						<IntegrationCard
							title={card?.title}
							buttonText={card?.buttonText}
							logo={card?.logo}
							ghost={card?.ghost}
							onClick={connectionHandler}
						/>
					</Col>
				);
			})}
		</Row>
	);
};

export default Connection;
